import { LanguageId } from 'lib-knowledge-management-common/graphql';
import {
  CategoryRef,
  CollectionRef,
} from 'lib-knowledge-management-common/models/types';
import { z } from 'zod';

export const collectionSchema = z.object({
  __typename: z.literal('Collection'),
  id: z.string(),
});
type CollectionSchema = z.infer<typeof collectionSchema>;

const _checkCollection: CollectionSchema = {
  __typename: 'Collection',
  id: 'e058832e-ef62-47c4-bc96-36fa8950bf34',
} satisfies CollectionRef; // ensure zod schema overlaps existing type

export const categorySchema = z.object({
  __typename: z.literal('Category'),
  id: z.string(),
});
type CategorySchema = z.infer<typeof categorySchema>;

const _checkCategory: CategorySchema = {
  __typename: 'Category',
  id: 'db1d0f65-0859-4d0f-b416-5e05ddf50855',
} satisfies CategoryRef; // ensure zod schema overlaps existing type

const categoryTitle = z.object({
  languageId: z.nativeEnum(LanguageId),
  /**
   * We do a union here so that untouched fields that are empty will not trigger
   * a form isInvalid error state. Once the user starts typing, the field will
   * be assigned a string value and the field will be validated from that point
   * onwards.
   */
  title: z.string().optional(),
});
export type CategoryTitle = z.infer<typeof categoryTitle>;

const categoryParentRef = z
  .union([categorySchema, collectionSchema])
  .optional();
export type CategoryParentRef = z.infer<typeof categoryParentRef>;
export const categoryEditModalSchema = z.object({
  titles: z.array(categoryTitle),
  parentRef: categoryParentRef,
});

export type CategoryEditModalSchema = z.infer<typeof categoryEditModalSchema>;
